export enum FileType {
  Application = 'Application',
  Profile = 'Profile',
}

export enum PackageType {
  CitizenM = 'CitizenM',
  IreckonU = 'IreckonU',
}
